import { render, staticRenderFns } from "./Substances.vue?vue&type=template&id=3acbb86c&scoped=true"
import script from "./Substances.vue?vue&type=script&lang=js"
export * from "./Substances.vue?vue&type=script&lang=js"
import style0 from "./Substances.vue?vue&type=style&index=0&id=3acbb86c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acbb86c",
  null
  
)

export default component.exports